// eslint-disable-next-line import/no-unresolved
import { Content } from '@plone/types';
import { BaseSchema, SchemaModifier } from '../types';
import { generateSchema } from '../SchemaGeneration';
import { generateKnowsAbout } from '../utils';

const universityModifier: SchemaModifier = (
  content,
  main,
  parts,
  state,
  partial,
) => {
  const is_main_university = content?.['@id']?.endsWith('/fhnw');

  if (is_main_university) {
    content['@components']?.universities?.forEach((university: Content) => {
      parts.push(
        generateSchema({
          type: 'University',
          content: {
            ...university,
            '@components': {
              main_university: main['identifier'],
            },
          } as Content,
          state,
        }) as BaseSchema,
      );
    });
  } else if (content['@components']?.main_university) {
    main['parentOrganization'] = generateSchema({
      type: 'University',
      content: content['@components'].main_university as Content,
      state,
      partial: true,
    });

    if (content?.research_areas) {
      main['knowsAbout'] = generateKnowsAbout(content.research_areas);
    }
  }
};

export default universityModifier;
